import React from "react";
import { View, ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import MultiEshopViewModel from "../../viewModels/multiEshop/multiEshopViewModel";
import { registerView } from "@frui.ts/views/dist";

const multiEshopView: ViewComponent<MultiEshopViewModel> = observer(({ vm }) => (
  <>
    {vm.showOutages && (
      <>
        <View vm={vm.payGateOutagesViewModel} />
        <View vm={vm.eshopOutagesVieModel} />
      </>
    )}
    <View vm={vm.activeChild} />
  </>
));

registerView(multiEshopView, MultiEshopViewModel);
